import {environment} from "@environments/environment";
import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: 'toTemplateUrl'})
export class ResourceTemplatePipe implements PipeTransform {

  transform(templatePath: string) {
    return environment.templateBaseUrl + templatePath;
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-factures/digicerba-factures-web/src/angular/cerba/src/app/common/utils/template/resource.template.pipe.ts